/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    CLEAR_RECIPIENT_TYPE,
    LOAD_APP,
    SET_BRAND_CONFIG,
    SET_FEATURE_FLAG,
    SET_RECIPIENT_TYPE,
    SET_RELATIONSHIP_LIST,
    SET_RECAPTCHA_CHECKOUT_V2_TOKEN,
    CLEAR_RECAPTCHA_CHECKOUT_V2_TOKEN,
    SHORTENED_SALEFORCE_AB_TEST,
    ONE_PAGE_CHECKOUT_SALEFORCE_AB_TEST,
    SET_IS_AUTH0_TRIGGER_CALLED,
    MIDDLE_PLACE_ORDER_SALEFORCE_AB_TEST,
    REMEMBER_ME_SALEFORCE_AB_TEST,
    CALENDAR_MESSAGE_AB_TEST,
    MODAL_QAS_RADIO_BUTTONS_SALEFORCE_AB_TEST,
    CHECK_UNVERIFIED_ADDRESSES_SALEFORCE_AB_TEST,
    DELIVERY_DATE_SELECTIONS_SALESFORCE_AB_TEST,
    LONGER_PASSPORT_MESSAGE_SALESFORCE_AB_TEST,
    ENTERPRISE_CALENDAR_SALESFORCE_AB_TEST,
    DELIVERY_TIME_WINDOW_SALESFORCE_AB_TEST,
    SET_NEW_PRODUCT_CARD_LAYOUT_ENABLED,
    CARDISLE_GRID_VIEW_SALEFORCE_AB_TEST,
    ORDER_SUMMARY_REMAPPING_SALESFORCE_AB_TEST,
} from './App-ActionTypes';

export const loadApp = () => ({
    type: LOAD_APP,
});

export const setBrandConfig = (data) => ({
    type: SET_BRAND_CONFIG,
    payload: data,
});

export const setFeatureFlag = (data) => ({
    type: SET_FEATURE_FLAG,
    payload: data,
});

export const setRelationshipList = (data) => ({
    type: SET_RELATIONSHIP_LIST,
    payload: data,
});

export const setRecipientType = (data) => ({
    type: SET_RECIPIENT_TYPE,
    payload: data,
});

export const setRecaptchaCheckoutV2Token = (data) => ({
    type: SET_RECAPTCHA_CHECKOUT_V2_TOKEN,
    payload: data,
});

export const clearRecaptchaCheckoutV2Token = (data) => ({
    type: CLEAR_RECAPTCHA_CHECKOUT_V2_TOKEN,
    payload: data,
});

export const clearRecipientType = () => ({
    type: CLEAR_RECIPIENT_TYPE,
});

export const setShortenedShippingSaleForceABTest = (abTestData) => ({
    type: SHORTENED_SALEFORCE_AB_TEST,
    payload: abTestData,
});

export const setOnePageCheckoutSaleForceABTest = (abTestData) => ({
    type: ONE_PAGE_CHECKOUT_SALEFORCE_AB_TEST,
    payload: abTestData,
});

export const setIsAuth0TriggerCalled = (isTrigger) => ({
    type: SET_IS_AUTH0_TRIGGER_CALLED,
    payload: isTrigger,
});

export const setMiddlePlaceOrderSaleForceABTest = (abTestData) => ({
    type: MIDDLE_PLACE_ORDER_SALEFORCE_AB_TEST,
    payload: abTestData,
});

export const setRememberMeSaleForceABTest = (abTestData) => ({
    type: REMEMBER_ME_SALEFORCE_AB_TEST,
    payload: abTestData,
});

export const setCalendarMessageSaleForceABTest = (abTestData) => ({
    type: CALENDAR_MESSAGE_AB_TEST,
    payload: abTestData,
});

export const setModalQasRadioButtonsSaleForceABTest = (abTestData) => ({
    type: MODAL_QAS_RADIO_BUTTONS_SALEFORCE_AB_TEST,
    payload: abTestData,
});

export const setCheckUnverifiedAddressesSaleForceABTest = (abTestData) => ({
    type: CHECK_UNVERIFIED_ADDRESSES_SALEFORCE_AB_TEST,
    payload: abTestData,
});

export const setDeliveryDateSelectionsSalesForceABTest = (abTestData) => ({
    type: DELIVERY_DATE_SELECTIONS_SALESFORCE_AB_TEST,
    payload: abTestData,
});

export const setLongerPassportMessageSalesForceABTest = (abTestData) => ({
    type: LONGER_PASSPORT_MESSAGE_SALESFORCE_AB_TEST,
    payload: abTestData,
});

export const setEnterpriseCalendarSalesForceABTest = (abTestData) => ({
    type: ENTERPRISE_CALENDAR_SALESFORCE_AB_TEST,
    payload: abTestData,
});

export const setDeliveryTimeWindowSalesForceABTest = (abTestData) => ({
    type: DELIVERY_TIME_WINDOW_SALESFORCE_AB_TEST,
    payload: abTestData,
});

export const setNewProductCardLayoutEnabled = () => ({
    type: SET_NEW_PRODUCT_CARD_LAYOUT_ENABLED,
});

export const setOrderSummaryRemappingSalesforceABTest = (abTestData) => ({
    type: ORDER_SUMMARY_REMAPPING_SALESFORCE_AB_TEST,
    payload: abTestData,
});

export const setCardisleGridViewSaleForceABTest = (abTestData) => ({
    type: CARDISLE_GRID_VIEW_SALEFORCE_AB_TEST,
    payload: abTestData,
});

export default {};
